// src/components/NewsItem.js
import React from "react";
import styled from "styled-components";

const Card = styled.div`
  background: #131313;
  border: 1px solid #00FF41;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: scale(1.01);
    box-shadow: 0 0 10px #00FF41;
  }
`;

const Title = styled.h2`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

const Status = styled.span`
  display: inline-block;
  margin: 0.5rem 0;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  font-weight: bold;
  background-color: ${({ status }) =>
    status === "True"
      ? "green"
      : status === "False"
      ? "red"
      : "orange"};
  color: #fff;
`;

const Content = styled.p`
  font-size: 0.95rem;
  line-height: 1.4;
  color: #b3ffce;
`;

const SourceLink = styled.a`
  display: inline-block;
  margin-top: 0.5rem;
  color: #a3ffa0;
  text-decoration: underline;

  &:hover {
    color: #fff;
  }
`;

const NewsItem = ({ title, content, status, source }) => {
  return (
    <Card>
      <Title>{title}</Title>
      <Status status={status}>AI Analysis: {status}</Status>
      <Content>{content}</Content>
      {source && (
        <SourceLink href={source} target="_blank" rel="noreferrer">
          Read full article
        </SourceLink>
      )}
    </Card>
  );
};

export default NewsItem;
